import { me } from "@api/courses/stats/users/me/api";

export const users = {
  me,
};
